export const createUserUrl = "/user/createUser";
export const editUserUrl = "/user/editUser";
export const allUsersUrl = "/user/allUsers";
export const removeUserUrl = "/user/removeUser/{username}";
